// extracted by mini-css-extract-plugin
export default {"form":"SearchForm_form__49W6b","inputWrapper":"SearchForm_inputWrapper__279p6","preview":"SearchForm_preview__a7ap5","image":"SearchForm_image__w9ACU"};